import axios from './axiosConfig';

export const submitSurvey = async (collectionType, surveyAnswers) => {
  if (collectionType === 'Marketing') collectionType = 'Social';
  const url = '/fs/surveys/create';
  const payload = {
    surveyAnswers,
    collectionType,
  };
  const { data } = await axios.post(url, payload);
  return data;
};

export const deleteSurvey = async (collectionType, surveyId) => {
  if (collectionType === 'Marketing') collectionType = 'Social';
  const url = '/fs/surveys/delete';
  const payload = {
    collectionType,
    surveyId,
  };

  const { data } = await axios.delete(url, { data: payload });

  return data;
};

export const updateSurvey = async (collectionType, surveyId, updatedSurveyData) => {
  if (collectionType === 'Marketing') collectionType = 'Social';
  const url = '/fs/surveys/edit';
  const payload = {
    collectionType,
    surveyId,
    updatedSurveyData,
  };

  const { data } = await axios.put(url, payload);

  return data;
};

export const changeUserAgency = async (userEmail, targetAgencyUserEmail) => {
  const url = '/fs/change-user-agency';
  const payload = {
    userEmail,
    targetAgencyUserEmail,
  };
  const { data } = await axios.post(url, payload);
  return data;
};

export const assignAgencyToCompany = async (userEmail, targetAgencyUserEmail) => {
  const url = '/fs/assign-agency-to-company';
  const payload = {
    userEmail,
    targetAgencyUserEmail,
  };
  const { data } = await axios.post(url, payload);
  return data;
};

export const changeUserDisplayName = async (userEmail, newDisplayName) => {
  const url = '/fs/change-user-display-name';
  const payload = {
    userEmail,
    newDisplayName,
  };
  const { data } = await axios.post(url, payload);
  return data;
};

export const upgradeUserToAdmin = async userEmail => {
  const url = '/fs//upgrade-user-to-admin';
  const payload = {
    userEmail,
  };
  const { data } = await axios.post(url, payload);
  return data;
};

export const AITextGenerator = (
  brandName,
  contentType,
  platform,
  title,
  keyword1,
  keyword2,
  keyword3,
  background,
  objective,
  audience,
  customerInsight,
  keyMessage,
  rtb,
  creativeDirection,
  budget,
) => {
  return new Promise((resolve, reject) => {
    const url = '/ai/marketing-content-content';
    const data = {
      brandName,
      contentType,
      platform,
      title,
      keyword1,
      keyword2,
      keyword3,
      background,
      objective,
      audience,
      customerInsight,
      keyMessage,
      rtb,
      creativeDirection,
      budget,
    };
    axios
      .post(url, data)
      .then(response => {
        if (!response.data.error) {
          resolve(response.data.result);
        } else {
          reject('An error occurred while calulcating the data');
        }
      })
      .catch(err => {
        console.log(err);
        reject('An error occurred while generating AI post');
      });
  });
};

export const AITextRegenerator = (
  brandName,
  contentType,
  platform,
  title,
  keyword1,
  keyword2,
  keyword3,
  background,
  objective,
  audience,
  customerInsight,
  keyMessage,
  rtb,
  creativeDirection,
  budget,
  regenerationRequest,
) => {
  return new Promise((resolve, reject) => {
    const url = '/ai/marketing-content-content/regenerate';
    const data = {
      brandName,
      contentType,
      platform,
      title,
      keyword1,
      keyword2,
      keyword3,
      background,
      objective,
      audience,
      customerInsight,
      keyMessage,
      rtb,
      creativeDirection,
      budget,
      regenerationRequest,
    };
    axios
      .post(url, data)
      .then(response => {
        if (!response.data.error) {
          resolve(response.data.result);
        } else {
          reject('An error occurred while calulcating the data');
        }
      })
      .catch(err => {
        console.log(err);
        reject('An error occurred while generating AI post');
      });
  });
};

export const AIProductSocialCausesAnswerGenerator = async (Post_Category, postText) => {
  try {
    const productUrl = '/ai/product-clasify';
    const socialUrl = '/ai/social-and-causes-clasify';

    // Category 1 → Product only
    if (Post_Category == 1) {
      const res = await axios.post(productUrl, { postText });
      if (res.data.error) throw new Error();
      return res.data.result;
    }

    // Category 3,4,5 → Social only
    if ([3, 4, 5].includes(Number(Post_Category))) {
      const res = await axios.post(socialUrl, { postText });
      if (res.data.error) throw new Error();
      return res.data.result;
    }

    // Category 2 → Both
    if (Post_Category == 2) {
      const [productRes, socialRes] = await Promise.all([
        axios.post(productUrl, { postText }),
        axios.post(socialUrl, { postText }),
      ]);

      if (productRes.data.error || socialRes.data.error) {
        throw new Error();
      }

      // Merge results
      return {
        ...productRes.data.result,
        ...socialRes.data.result,
      };
    }

    throw new Error('Invalid data');
  } catch (err) {
    throw new Error('An error occurred while processing');
  }
};

export const extractMarketingBriefFromFile = async ({ file, surveyId }) => {
  const arrayBuffer = await file.arrayBuffer();
  const bytes = new Uint8Array(arrayBuffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }

  const payload = {
    surveyId,
    fileName: file.name,
    mimeType: file.type,
    size: file.size,
    contentBase64: btoa(binary),
  };

  const { data } = await axios.post('/ai/marketing-brief/extract', payload);
  return data;
};

export const extractCampaignPitchFromFile = async ({ file, surveyId, context }) => {
  const arrayBuffer = await file.arrayBuffer();
  const bytes = new Uint8Array(arrayBuffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }

  const payload = {
    surveyId,
    context,
    fileName: file.name,
    mimeType: file.type,
    size: file.size,
    contentBase64: btoa(binary),
  };

  const { data } = await axios.post('/ai/marketing-campaign-pitch/extract', payload);
  return data;
};

export const extractBrandPersonaFromFile = async ({ file, surveyId, context }) => {
  const arrayBuffer = await file.arrayBuffer();
  const bytes = new Uint8Array(arrayBuffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i += 1) {
    binary += String.fromCharCode(bytes[i]);
  }

  const payload = {
    surveyId,
    context,
    fileName: file.name,
    mimeType: file.type,
    size: file.size,
    contentBase64: btoa(binary),
  };

  const { data } = await axios.post('/ai/brand-persona/open-ended/extract', payload);
  return data;
};

export const classifyBrandPersonaFromAnalysis = async ({ surveyId, context, openEndedAnswers }) => {
  const { data } = await axios.post('/ai/brand-persona/classify', {
    surveyId,
    context,
    openEndedAnswers,
  });
  return data;
};
const normalizeStrategyVersions = (strategyVersions, fallbackStrategyText) => {
  const normalized = Array.isArray(strategyVersions)
    ? strategyVersions
        .map((item, index) => ({
          versionNumber: Number(item?.versionNumber) || index + 1,
          text:
            typeof item?.text === 'string'
              ? item.text
              : typeof item?.value === 'string'
              ? item.value
              : typeof item?.strategy === 'string'
              ? item.strategy
              : typeof item?.content === 'string'
              ? item.content
              : '',
          createdAt: item?.createdAt || new Date().toISOString(),
          baseVersionNumber: Number(item?.baseVersionNumber) || null,
        }))
        .filter(item => item.text.trim().length > 0)
    : [];

  if (!normalized.length && typeof fallbackStrategyText === 'string' && fallbackStrategyText.trim().length > 0) {
    return [
      {
        versionNumber: 1,
        text: fallbackStrategyText.trim(),
        createdAt: new Date().toISOString(),
        baseVersionNumber: null,
      },
    ];
  }

  return normalized.sort((a, b) => Number(a.versionNumber) - Number(b.versionNumber));
};

const updateSocialPostMarketingStrategy = async (
  socialPostID,
  brandPersonaID,
  newStrategy,
  oldStrategies,
  oldStrategyVersions,
  baseVersionNumber,
) => {
  try {
    if (typeof oldStrategies === 'undefined') oldStrategies = {};
    if (typeof oldStrategyVersions === 'undefined') oldStrategyVersions = {};

    const existingForPersona = normalizeStrategyVersions(
      oldStrategyVersions?.[brandPersonaID],
      oldStrategies?.[brandPersonaID],
    );
    const nextVersionNumber = existingForPersona.length + 1;
    const nextVersion = {
      versionNumber: nextVersionNumber,
      text: newStrategy,
      createdAt: new Date().toISOString(),
      baseVersionNumber:
        Number(baseVersionNumber) ||
        (existingForPersona.length ? existingForPersona[existingForPersona.length - 1].versionNumber : 1),
    };
    const updatedVersionsForPersona = [...existingForPersona, nextVersion];

    const newData = {
      marketingStrategies: {
        ...oldStrategies,
        [brandPersonaID]: newStrategy,
      },
      marketingStrategyVersions: {
        ...oldStrategyVersions,
        [brandPersonaID]: updatedVersionsForPersona,
      },
    };

    const response = await updateSurvey('social', socialPostID, newData);
    if (!response.err) {
      return {
        err: false,
        errMessage: '',
      };
    } else {
      return {
        err: true,
        errMessage: response.errMessage,
      };
    }
  } catch (err) {
    return {
      err: true,
      errMessage: err.message,
    };
  }
};

export const AISocialMediaStrategyGenerator = (data, socialPostPickedId, brandPersonaPickedId, marketingStrategies) => {
  return new Promise((resolve, reject) => {
    const url = '/ai/marketing-content-strategy';
    axios
      .post(url, data)
      .then(response => {
        if (!response.data.error) {
          updateSocialPostMarketingStrategy(
            socialPostPickedId,
            brandPersonaPickedId,
            response.data.result,
            marketingStrategies,
            data.marketingStrategyVersions,
            data.baseVersionNumber,
          )
            .then(res => {
              if (!res.err) {
                resolve(response.data.result);
              } else {
                console.log(res.errMessage);
                reject('An error occurred while trying to save marketing strategy.');
              }
            })
            .catch(err => {
              console.log(err.message);
              reject('An error occurred while trying to save marketing strategy.');
            });
        } else {
          reject('An error occurred while calulcating the data');
        }
      })
      .catch(err => {
        console.log(err);
        reject('An error occurred while generating AI strategy');
      });
  });
};

export const AISocialMediaStrategyRegenerator = (
  data,
  socialPostPickedId,
  brandPersonaPickedId,
  marketingStrategies,
  marketingStrategyVersions,
  baseVersionNumber,
) => {
  return new Promise((resolve, reject) => {
    const url = '/ai/marketing-content-strategy/regenerate';
    axios
      .post(url, data)
      .then(response => {
        if (!response.data.error) {
          updateSocialPostMarketingStrategy(
            socialPostPickedId,
            brandPersonaPickedId,
            response.data.result,
            marketingStrategies,
            marketingStrategyVersions,
            baseVersionNumber,
          )
            .then(res => {
              if (!res.err) {
                resolve(response.data.result);
              } else {
                reject('An error occurred while trying to save marketing strategy.');
              }
            })
            .catch(() => reject('An error occurred while trying to save marketing strategy.'));
        } else {
          reject('An error occurred while calulcating the data');
        }
      })
      .catch(() => reject('An error occurred while generating AI strategy'));
  });
};

export const checkAuthState_API = async () => {
  const response = await axios.get('/auth/check');
  return response;
};

export const AIChatBot = messages => {
  return new Promise((resolve, reject) => {
    const url = '/ai/chat-ask';
    const data = { messages };
    axios
      .post(url, data)
      .then(response => {
        if (!response.data.error) {
          resolve(response.data.result);
        } else {
          reject('An error occurred while generating response');
        }
      })
      .catch(err => {
        reject('An error occurred while connecting to the chat assistant');
      });
  });
};

export const getMoodBoard = async (socialPostId, brandPersonaId) => {
  const { data } = await axios.get('/ai/marketing-content-moodboard', {
    params: { socialPostId, brandPersonaId },
  });

  if (data.error) throw new Error(data.result || 'Failed to fetch mood board');
  return data.result;
};

export const generateMoodBoard = async (socialPostId, brandPersonaId) => {
  const { data } = await axios.post('/ai/marketing-content-moodboard/generate', { socialPostId, brandPersonaId });

  if (data.error) throw new Error(data.result || 'Failed to generate mood board');
  return { result: data.result, cached: Boolean(data.cached) };
};

export const regenerateMoodBoard = async (socialPostId, brandPersonaId) => {
  const { data } = await axios.post('/ai/marketing-content-moodboard/regenerate', { socialPostId, brandPersonaId });

  if (data.error) throw new Error(data.result || 'Failed to regenerate mood board');
  return { result: data.result, cached: false };
};

export const getCampaignVideo = async (socialPostId, brandPersonaId) => {
  const { data } = await axios.get('/ai/marketing-content-video', {
    params: { socialPostId, brandPersonaId },
  });

  if (data.error) throw new Error(data.result || 'Failed to fetch campaign video');
  return data.result;
};

export const generateCampaignVideo = async (socialPostId, brandPersonaId) => {
  const { data } = await axios.post('/ai/marketing-content-video/generate', { socialPostId, brandPersonaId });

  if (data.error) throw new Error(data.result || 'Failed to generate campaign video');
  return data.result;
};

export const regenerateCampaignVideo = async ({
  socialPostId,
  brandPersonaId,
  regenerationMode,
  revisionInputs,
  baseVideoId,
  baseVersionNumber,
}) => {
  const { data } = await axios.post('/ai/marketing-content-video/regenerate', {
    socialPostId,
    brandPersonaId,
    baseVideoId,
    baseVersionNumber,
    regenerationMode,
    revisionInputs,
  });

  if (data.error) throw new Error(data.result || 'Failed to regenerate campaign video');
  return data.result;
};
